import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/detalle-de-subsidio';

const getValuesAndConfig = (values) => {
  const config = hasFiles(values) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Detalle Subsidios
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDetalleSubsidios = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Detalle Subsidio
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDetalleSubsidio = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Detalle Subsidio
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDetalleSubsidio = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Detalle Subsidio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDetalleSubsidio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Detalle Subsidio
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDetalleSubsidio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
